import classNames from "classnames";
import AIGenerateButtonStar from "static/images/AIGenerateButtonStar.svg";
import "../../../static/styles/components/gradient.css";

export const GradientButton = ({
  onClick,
  children,
  className,
}: {
  onClick?: () => void;
  className?: string;
  children: string;
}) => (
  <button
    onClick={onClick}
    className={classNames(
      "t-relative t-border-none t-bg-surface-transparent t-inline-flex t-items-center t-cursor-pointer t-gap-1 t-px-1 t-py-0.5",
      {
        [className as string]: className,
      }
    )}
  >
    <img src={AIGenerateButtonStar} alt="AIGenerateStar" />
    <span className="gradient-text t-text-subtext-sm t-text-text-60 t-w-fit t-inline-block">
      {children}
    </span>
  </button>
);
